// Mobile never prompts during an active hunt and never mid-flow. On web the
// equivalents are the live team map and the plan-hunt wizard: one is the surface
// a user is actively working on, the other is a multi-step form where an overlay
// would compete with the step they are filling in.
const BLOCKED_PREFIXES = ['/hunts/plan'] as const
const BLOCKED_PATTERNS = [/^\/teams\/[^/]+\/map$/] as const

// An allowlist rather than a denylist: a route added later is not silently
// treated as a good place to interrupt someone. A new calm route is one line
// here, and the test file is where that intent gets recorded.
const CALM_PREFIXES = ['/dogs', '/devices', '/hunts', '/teams', '/settings'] as const

export function isCalmNpsRoute(pathname: string): boolean {
  const path = pathname.length > 1 && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname

  if (BLOCKED_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`))) return false
  if (BLOCKED_PATTERNS.some((p) => p.test(path))) return false
  if (path === '/') return true
  return CALM_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`))
}
